(() => {
  const root = document.getElementById('satellai-cookie-preferences');
  if (!root) return;
  const MIRROR_COOKIE = 'satellai_consent';
  const MIRROR_MAX_AGE = 60 * 60 * 24 * 365;
  const getToggles = () => Object.fromEntries([...root.querySelectorAll('[data-cookie-preferences-toggle]')].map((input) => [input.dataset.cookiePreferencesToggle, input]));
  const setOpen = (open) => {
    root.hidden = !open;
    document.documentElement.classList.toggle('satellai-cookie-preferences-open', open);
    document.body.classList.toggle('satellai-cookie-preferences-open', open);
    if (open) root.querySelector('[data-cookie-preferences-close]').focus();
  };
  const writeMirrorCookie = (choices) => {
    try {
      const value = encodeURIComponent(JSON.stringify({ v: 1, s: { a: choices.analytics, m: choices.marketing, p: choices.preferences }, t: Date.now() }));
      const secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = MIRROR_COOKIE + '=' + value + '; Path=/; Max-Age=' + MIRROR_MAX_AGE + '; SameSite=Lax' + secure;
    } catch (error) {
      // Shopify remains the source of truth; this cookie only restores Consent Mode before GTM loads on a later visit.
    }
  };
  const pushGoogleConsent = (choices) => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'update', { analytics_storage: choices.analytics ? 'granted' : 'denied', ad_storage: choices.marketing ? 'granted' : 'denied', ad_user_data: choices.marketing ? 'granted' : 'denied', ad_personalization: choices.marketing ? 'granted' : 'denied', functionality_storage: choices.preferences ? 'granted' : 'denied', personalization_storage: choices.preferences ? 'granted' : 'denied' });
    window.dataLayer.push({ event: 'satellai_consent_update', consent_analytics: choices.analytics, consent_marketing: choices.marketing, consent_preferences: choices.preferences, consent_source: 'satellai_cookie_preferences' });
  };
  const pushConsent = (choices, done) => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    // Consent Mode must be updated in the same click task. Waiting for Shopify's
    // persistence callback lets subsequently-fired GA4 events retain the old g111 state.
    writeMirrorCookie(choices);
    pushGoogleConsent(choices);
    const complete = () => { if (typeof done === 'function') done(); };
    if (privacy && typeof privacy.setTrackingConsent === 'function') {
      privacy.setTrackingConsent({ analytics: choices.analytics, marketing: choices.marketing, preferences: choices.preferences, sale_of_data: choices.marketing }, complete);
      return;
    }
    complete();
  };
  const save = (choices) => { Object.entries(getToggles()).forEach(([key, input]) => { input.checked = choices[key]; }); pushConsent(choices, () => setOpen(false)); };
  const restore = () => {
    const toggles = getToggles(); const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return;
    const value = privacy.currentVisitorConsent(); Object.entries(toggles).forEach(([key, input]) => { input.checked = value[key] === 'yes'; });
  };
  document.addEventListener('click', (event) => {
    const customManage = event.target.closest('[data-satellai-open-cookie-preferences]');
    if (customManage) { restore(); setOpen(true); return; }
    const manage = event.target.closest('#shopify-pc__banner__btn-manage-prefs');
    if (manage) { event.preventDefault(); event.stopImmediatePropagation(); restore(); setOpen(true); return; }
    if (event.target.closest('[data-cookie-preferences-close]')) return setOpen(false);
    if (event.target.closest('[data-cookie-preferences-accept]')) return save({ analytics: true, marketing: true, preferences: true });
    if (event.target.closest('[data-cookie-preferences-reject]')) return save({ analytics: false, marketing: false, preferences: false });
    if (event.target.closest('[data-cookie-preferences-save]')) { const t = getToggles(); return save({ analytics: t.analytics.checked, marketing: t.marketing.checked, preferences: t.preferences.checked }); }
  }, true);
})();
